import { createPortal } from "react-dom";
import { type TooltipPosition, type TooltipSide, tooltipStyle } from "./tooltipPosition";

interface TooltipBubbleProps {
  id: string;
  label: string;
  position: TooltipPosition;
  side: TooltipSide;
}

/** The tooltip itself, portaled to <body>. */
export function TooltipBubble({ id, label, position, side }: TooltipBubbleProps): React.JSX.Element {
  return createPortal(
    <div id={id} role="tooltip" className="nb-tooltip" style={tooltipStyle(position, side)}>
      {label}
    </div>,
    document.body,
  );
}
